import { useState } from "react";
import useTranslation from "~/kernel/internationalization/useTranslation";
import ROUTES from "~/kernel/routing/ROUTES";
import { FormFieldsWrapper } from "~/ui";
import Input from "~/ui/Input";
import Link from "~/ui/Link";
import PasswordInput from "~/ui/PasswordInput";

type Props = {
  defaultEmail?: string;
  onEmailChange?: (email: string) => void;
};

export default function SignInFormFields({
  defaultEmail = "",
  onEmailChange,
}: Props) {
  const { tt } = useTranslation("login");
  const [email, setEmail] = useState(defaultEmail);

  const handleEmailChange = (value: string) => {
    setEmail(value);
    onEmailChange?.(value);
  };

  return (
    <FormFieldsWrapper>
      <Input
        id="email"
        type="email"
        label={tt("email")}
        autocomplete="email"
        value={email}
        onChange={(ev) => handleEmailChange(ev.target.value)}
        required
      />
      <PasswordInput
        id="password"
        autocomplete="current-password"
        iconTabIndex={-1}
        label={
          <div className="flex justify-between">
            <label htmlFor="password">
              {tt("password")} <span className="text-error">*</span>
            </label>
            <Link
              to={ROUTES.passwordReset.new.path({ query: { email } })}
              tabIndex={-1}
            >
              {tt("forgotPassword")}
            </Link>
          </div>
        }
        required
      />
    </FormFieldsWrapper>
  );
}
